// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-form {
    min-width: 150px;
    max-width: 500px;
    width: 100%;
    margin-top: 16px;
  }
  
  .example-full-width {
    width: 100%;
  }

  .center {
    margin: auto;
    width: 50%;
    padding: 10px;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/app/aplikacija/izbira-skladisca/izbira-skladisca.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB","sourcesContent":[".example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n    margin-top: 16px;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n\n  .center {\n    margin: auto;\n    width: 50%;\n    padding: 10px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
